import React, { createContext, useContext, useMemo, useState } from 'react';

type CrisisCommunicationsHeaderActionsContextValue = {
  actions: React.ReactNode;
  setActions: (actions: React.ReactNode) => void;
};

const CrisisCommunicationsHeaderActionsContext =
  createContext<CrisisCommunicationsHeaderActionsContextValue | null>(null);

export const CrisisCommunicationsHeaderActionsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [actions, setActions] = useState<React.ReactNode>(null);
  const value = useMemo(() => ({ actions, setActions }), [actions]);

  return (
    <CrisisCommunicationsHeaderActionsContext.Provider value={value}>
      {children}
    </CrisisCommunicationsHeaderActionsContext.Provider>
  );
};

export function useCrisisCommunicationsHeaderActions(): CrisisCommunicationsHeaderActionsContextValue {
  const context = useContext(CrisisCommunicationsHeaderActionsContext);
  if (!context) {
    throw new Error(
      'useCrisisCommunicationsHeaderActions must be used within CrisisCommunicationsHeaderActionsProvider'
    );
  }
  return context;
}

export const CrisisCommunicationsHeaderActionsSlot: React.FC = () => {
  const { actions } = useCrisisCommunicationsHeaderActions();
  if (!actions) return null;

  return (
    <div className="ml-4 shrink-0 flex items-center gap-2 flex-wrap justify-end">
      {actions}
    </div>
  );
};
